<form [formGroup]="formGroup()">
  <div class="grid grid-cols-1 gap-4">
    <div class="flex flex-col gap-2">
      <label for="number" appRequiredLabel="numerKonta"
        >Numer rachunku w państwie UE/EFTA albo Wielkiej Brytanii, którego
        jestem właścicielem albo współwłaścicielem</label
      >
      <input
        id="number"
        [maxlength]="34"
        [style]="{ width: '50%' }"
        [formControl]="formGroup().controls.numerKonta"
        pInputText
        appControlError
      />
      @if (isAccountFromUEEFTA()) {
        <span class="account-number-ueefta-validation"
          >Numer nie należy do państw UE/EFTA albo Wielkiej Brytanii
        </span>
      }
    </div>
    <div class="flex flex-col gap-2">
      <label for="bankDetails" appRequiredLabel="daneBanku"
        >Nazwa i adres banku</label
      >
      <input
        id="bankDetails"
        [maxlength]="350"
        pInputText
        appControlError
        [formControl]="formGroup().controls.daneBanku"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="bankIdentificator" appRequiredLabel="identyfikatorBanku"
        >Międzynarodowy identyfikator banku w formacie BIC/SWIFT</label
      >
      <input
        id="bankIdentificator"
        [maxlength]="11"
        pInputText
        appControlError
        [formControl]="formGroup().controls.identyfikatorBanku"
      />
    </div>
  </div>
</form>
